document.addEventListener('DOMContentLoaded', function () {
  // Variables
  var cartItem;
  
  // Function to format money
  function makeMoney(money) {
    return '$' + (money / 100).toFixed(2);
  }

  // Function to reset the cart
  function resetCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var totalItemsCount = 0;
        for (const item of cart.items) {
          totalItemsCount += item.quantity;
          const lineID = item.id;
          const linePrice = item.final_line_price;
          document.querySelector(`tr[data-id="${lineID}"] .price--end`).textContent = makeMoney(linePrice);
        }
        document.querySelector('.totals__subtotal-value').textContent = makeMoney(cart.total_price) + ' USD';
        document.querySelector('.cart-count-num').textContent = totalItemsCount;
      });
  }

  // Quantity Buttons
  document.querySelectorAll('.quantity_btn').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const cartItem = this.closest('tr');
      const variant_id = cartItem.dataset.id;
      const variant_inv = cartItem.dataset.inv;
      console.log(variant_inv);
      let quantity = parseInt(cartItem.querySelector('.quantity__input').value);
      quantity = this.classList.contains('btn-plus') ? quantity + 1 : Math.max(quantity - 1, 1);
      cartItem.querySelector('.stock-notice').textContent = '';
      if(variant_inv > quantity ){
        cartItem.querySelector('.quantity__input').value = quantity;
        const itemsArray = [variant_id];
        const data = { updates: {} };
        data.updates[itemsArray[0]] = quantity;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(response => {
          resetCart(response);
          realCartCount();
        })
        .catch(error => console.log('Error:', error));
      } else {

        cartItem.querySelector('.stock-notice').textContent = 'Only ' + variant_inv + ' available.';
      }
    });
  });

  // Remove Buttons
  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('.remove-btn');
    if (removeBtn) {
      console.log('remove-this-item');
      const tr = removeBtn.closest('tr');
      const thisItemId = tr.dataset.id;
      const itemsArray = [thisItemId];
      const qty = 0;
      const data = { updates: {} };
      for (const itemId of itemsArray) {
        data.updates[itemId] = qty;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then(() => {
        realCartCount();
        tr.remove();
        resetCart();
      })
      .catch(error => console.log('Error:', error));

      realCartCount();

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log(cart.items.length);
          if (cart.items.length === 0) {
            const forms = document.querySelectorAll('form');
            forms.forEach(form => {
              form.style.display = 'none';
            });

            window.location.href = '/cart';
          }
        });
    }
  });

  // Toggle Wrapper Details
  document.querySelectorAll('.wrapper-details').forEach(wrapper => {
    wrapper.addEventListener('click', function () {
      if (!this.hasAttribute("open")) {
        document.querySelector('.free-gift-wrap').classList.add('show');
        $("Cart-note").focus();
      } else {
        document.querySelector('.free-gift-wrap').classList.remove('show');
      }
    });
  });

  // Additional functions and code can be added here
});

// Custom Element: CartNote
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

// Custom Element: CartOccasion
class CartOccasion extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('change', (event) => {
      const selectedValue = event.target.id;

      // Check if the selected radio button's ID is "nowrapping"
      if (selectedValue === "nowrapping") {
        // Hide elements here
        hideElements();
      } else {
        // Reveal elements here
        revealElements();
      }

      // Update cart properties based on selected value
      const body = JSON.stringify({ properties: { occasion: selectedValue } });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    });
  }
}

// Define Custom Elements
customElements.define('cart-occasion', CartOccasion);

// Function to hide elements
function hideElements() {
  $('.gw-only').hide();
}

// Function to reveal elements
function revealElements() {
  $('.gw-only').show();
}

customElements.define('cart-note', CartNote);



// Check for IE and add form submission workaround
document.addEventListener('DOMContentLoaded', function() {


  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return (msie > 0 || trident > 0);
  }

  if (!isIE()) return;
  const cartSubmitInput = document.createElement('input');
  cartSubmitInput.setAttribute('name', 'checkout');
  cartSubmitInput.setAttribute('type', 'hidden');
  document.querySelector('#cart').appendChild(cartSubmitInput);
  document.querySelector('#checkout').addEventListener('click', function(event) {
    document.querySelector('#cart').submit();
  });
});

// Additional jQuery code
$(document).ready(function() {
  window.ZapietEvent.listen('widget_loaded', function(e) {
    $("#storePickupApp").insertAfter(".cart-items");
  });
});
